import { useQuery } from "@tanstack/react-query";
import { API_BASE_URL } from "@/backend/config";

type MaintenanceMode = {
  enabled: boolean;
  message: string;
  entered_at: string | null;
  entered_by: string | null;
};

async function fetchMaintenanceMode(): Promise<MaintenanceMode | null> {
  try {
    const res = await fetch(`${API_BASE_URL}/api/site-settings/maintenance_mode`);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data.setting?.value || null;
  } catch (error) {
    console.error("Failed to fetch maintenance mode:", error);
    return null;
  }
}

export function useMaintenanceMode() {
  return useQuery({
    queryKey: ["maintenance-mode"],
    queryFn: fetchMaintenanceMode,
    staleTime: 10_000, // Cache for 10 seconds
    refetchInterval: 30_000, // Poll every 30 seconds
    retry: false, // Don't retry on failure
  });
}

